import React, { useEffect } from "react";

import environment from "@common/environments";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useAuthContext } from "@main/context/Auth/Auth.context";

import { ModalHeader } from "../../Modal/ModalHeader/ModalHeader";

export function CancelSubscriptionBody({ onCancel }: { onCancel: () => void }) {
  const { userData } = useAuthContext();
  const { selectedWorkspace } = useAppSelectionContext();

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    const tallyObject = Tally;
    if (!tallyObject) return;

    tallyObject.loadEmbeds();
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    const tallyObject = Tally;
    if (!tallyObject) return;

    // eslint-disable-next-line
    function handler(event: MessageEvent<any>) {
      if (typeof event.data !== "string") return;
      if (!event.data.includes("Tally.FormSubmitted")) return;
      onCancel();
    }

    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, [onCancel]);

  const params = `?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&userId=${userData?.id}&userEmail=${userData?.email}&workspaceId=${selectedWorkspace?.id}`;
  const formURL =
    environment.name === "production"
      ? `https://forms.shakebugs.com/cancel_subscription${params}`
      : `https://forms.shakebugs.com/cancel_subscription_dev${params}`;

  return (
    <>
      <ModalHeader
        heading="OK, you're the boss"
        subtitle="Sorry to bug you, but why cancel Shake?"
      />
      <iframe
        data-tally-src={formURL}
        loading="lazy"
        onLoad={() => {
          /// iFrame loaded
          return;
        }}
        frameBorder="0"
        width="100%"
        height="450"
      ></iframe>
    </>
  );
}
